import React from 'react';
import { motion } from 'framer-motion';
export function VideoSection() {
  return <section className="pt-2 pb-10 sm:pt-4 sm:pb-14 px-4 flex justify-center bg-deco-bg relative z-10" data-id="element-212">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="relative rounded-[2rem] overflow-hidden shadow-2xl border-4 sm:border-8 border-white max-w-xs sm:max-w-sm w-full aspect-[9/16] bg-deco-card" data-id="element-213">
        <video src="https://cdn.magicpatterns.com/uploads/bVAumU95VTTWo2c6nzCrwD/IMG_7487.MOV" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-214" />
      </motion.div>
    </section>;
}